angular.module('user')
    .component('userPicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            customItems: "<?",
            required: "<?",
            modelType: '<?',
            pickMeEnabled: "<?",
            options: '<?',
            noneSelected: "<?",
            onChange: '&?',
            onNone: '&?',
            // filteringList: "="
        },
        templateUrl: "app/user/user-picker.html",
        controller: function(User, Principal) {
            const ctrl = this;

            ctrl.refreshList = q => {
                return User.autocomplete({q: q}).$promise.then(items => ctrl.items = sortUsers(items))
            }
            ctrl.refreshCustomItems = q => {
                ctrl.filteredCustomItems = filterUsers(ctrl.customItems, q)
            }
            ctrl.pickMe = () => {
                Principal.currentUser().then(user => {
                    ctrl.selected = user;
                    ctrl.onSelectionChanged(user, user);
                })
            }
            ctrl.toggleNone = () => {
                if(ctrl.noneSelected === true){
                    ctrl.noneSelected = null;
                }
                else {
                    ctrl.noneSelected = !(ctrl.noneSelected === true);
                }
                ctrl.onNone({$none: ctrl.noneSelected})
            }
            ctrl.isInactive = user => !!(user && (user.activated === false || user.active === false))

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";
                ctrl.required = ctrl.required || false;

                ctrl.noneFeatureEnabled = angular.isFunction(ctrl.onNone)

                const defaultOptions = {
                    placeholderKey: 'user.picker.placeholder'
                };
                ctrl.selectOptions = angular.extend({}, defaultOptions, ctrl.options);
                ctrl.refreshCustomItems();

                ctrl.ngModelCtrl.$render = () => ctrl.selectModelValue(ctrl.ngModelCtrl.$viewValue);
                ctrl.ngModelCtrl.$formatters.push(formatModelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? userId(viewValue) : viewValue);
                ctrl.selectModelValue(ctrl.ngModelCtrl.$modelValue);
            };

            ctrl.$onChanges = changes => {
                if (changes.customItems && ctrl.ngModelCtrl) {
                    ctrl.refreshCustomItems();
                    ctrl.selectModelValue(ctrl.ngModelCtrl.$modelValue);
                }
            };

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                if (angular.isFunction(ctrl.onChange)) {
                    ctrl.onChange({$user: $item});
                }
            };

            function toSelectedUser(value) {
                if (ctrl.modelType !== "id" || value == null || value === '') {
                    return value || null;
                }
                if (angular.isObject(value)) {
                    return value;
                }
                return findCustomItem(value) || null;
            }

            function formatModelValue(value) {
                return toSelectedUser(value) || value;
            }

            ctrl.selectModelValue = value => {
                ctrl.selected = toSelectedUser(value);
                const id = userId(value);
                if (ctrl.selected || ctrl.modelType !== "id" || id == null || angular.isObject(value)) {
                    return;
                }

                User.get({id: id}).$promise.then(user => {
                    if (String(userId(ctrl.ngModelCtrl.$modelValue)) === String(id)) {
                        ctrl.selected = user;
                    }
                });
            }

            function findCustomItem(id) {
                return (ctrl.customItems || [])
                    .find(item => item && String(item.id) === String(id));
            }

            function userId(value) {
                if (value == null || value === '') {
                    return null;
                }
                const id = angular.isObject(value) ? value.id : value;
                return isNaN(Number(id)) ? null : id;
            }

            function sortUsers(items) {
                if (!angular.isArray(items)) {
                    return [];
                }
                return items.slice().sort((a, b) => (a.fullName || '').localeCompare(b.fullName || ''));
            }

            function filterUsers(items, q) {
                const search = (q || '').toLowerCase();
                return sortUsers((items || []).filter(item => {
                    if (!item) {
                        return false;
                    }
                    return !search || (item.fullName || '').toLowerCase().includes(search);
                }));
            }
        }
    })
